export type Language = 'en' | 'ja';
export interface Translations {
  [id: string]: string;
}
export interface I18nMessages {
  en: Translations;
  ja: Translations;
}

const i18nTranslations: I18nMessages = {
  "en": {
    "Header.AppName.name": "Developer",
    "Header.Header.linkCircleCIHome": "circleci.com",
    "Header.Header.linkDocumentation": "Documentation",
    "Header.HeaderNavTabs.devhub": "Home",
    "Header.HeaderNavTabs.docs": "Documentation",
    "Header.HeaderNavTabs.images": "Images",
    "Header.HeaderNavTabs.orbs": "Orbs",
    "Header.HeaderNavTabs.jfc": "Jenkins Converter",
    "Header.SignupButton.loggedOutLabel": "Sign Up",
    "Header.SignupButton.loggedInLabel": "Go to Application",
    "Header.SignupButton.login": "Login",
    "Header.ImageTypes.machine.name": "Machine Images",
    "Header.ImageTypes.machine.body": "Use these images in your configuration to match the virtual machine required for your specific job.",
    "Header.ImageTypes.docker.name": "Convenience Images",
    "Header.ImageTypes.docker.body": "Use CircleCI’s pre-built Docker images for faster spin-up times and improved reliability.",
    "Banner.private-orbs.lede": "New",
    "Banner.private-orbs.body": "Private orbs now available on the CircleCI Scale plan. <cta>Read More</cta>",
    "Banner.private-orbs.ctaLink": "https://circleci.com/blog/circleci-private-orbs/",
    "Banner.dedicated-hosts-macos.lede": "New",
    "Banner.dedicated-hosts-macos.body": "Dedicated hosts for macOS now available on all paid plans. <cta>Learn more</cta>",
    "Banner.dedicated-hosts-macos.ctaLink": "https://circleci.com/docs/dedicated-hosts-macos",
    "Banner.sosd-2022.lede": "New",
    "Banner.sosd-2022.body": "The 2022 State of Software Delivery report details the tools and practices that make exceptional teams. <cta>Get the report</cta>",
    "Banner.sosd-2022.ctaLink": "https://www2.circleci.com/2022-state-of-software-delivery.html",
    "Banner.ubuntu-deprecation.lede": "Maintenance",
    "Banner.ubuntu-deprecation.body": "Ubuntu 14.04 and 16.04 machine images are deprecated. Brownouts will occur on March 29 & April 26 in advance of EOL on May 31, 2022. <cta>Learn more</cta>",
    "Banner.ubuntu-deprecation.ctaLink": "https://circleci.com/blog/ubuntu-14-16-image-deprecation/",
    "Banner.xcode-support-macos.lede": "Announcement",
    "Banner.xcode-support-macos.body": "Xcode 14.2.0 is the last Xcode version that will be supported by macOS medium and large resource classes. Starting mid-March, Free customers will be upgraded to our Gen2 macOS resources. <cta>Learn more</cta>",
    "Banner.xcode-support-macos.ctaLink": "https://discuss.circleci.com/t/macos-resource-deprecation-update/46891",
    "Banner.pipelines-maintenance.lede": "Maintenance",
    "Banner.pipelines-maintenance.body": "CircleCI scheduled maintenance is rescheduled from August 12, 2023, 16:00-17:00 UTC to September 23, 2023, 16:00-17:00 UTC. <cta>Read more</cta>",
    "Banner.pipelines-maintenance.ctaLink": "https://discuss.circleci.com/t/circleci-maintenance-september-23-16-00-17-00-utc-rescheduled-from-august-12-16-00-17-00-utc/48663",
    "Banner.close": "close",
    "helpfulResources.title": "Helpful Resources",
    "helpfulResources.newFeatures.title": "New features",
    "helpfulResources.newFeatures.description": "Track our platform changes. Stay up to date with the latest in CI.",
    "helpfulResources.newFeatures.category": "new",
    "helpfulResources.integrations.title": "Integrations",
    "helpfulResources.integrations.description": "Integrate your DevOps processes using orbs and our API.",
    "helpfulResources.integrations.category": "integrations",
    "helpfulResources.langGuides.title": "Language guides",
    "helpfulResources.langGuides.description": "Get help building the language & framework your app is written in.",
    "helpfulResources.langGuides.category": "guides",
    "helpfulResources.webhooks.title": "Webhooks",
    "helpfulResources.webhooks.description": "Create customizable integrations with workflow and job events.",
    "helpfulResources.webhooks.category": "integrations",
    "hero.heading_new": "Welcome to CircleCI",
    "hero.subhead_new": "CircleCI is the software delivery engine for teams who want to ship software faster, using code that’s reusable and easy to maintain. ",
    "hero.getting_started_btn_new": "Get Started",
    "hero.sign_up_free_btn_new": "Sign Up for Free",
    "hero.platform_action_button": "Go to Application",
    "hero.heading": "Everything you need to optimize your CI/CD pipeline",
    "hero.subhead": "Access our configuration packages (orbs), documentation, API, CLI, and other tools and resources.",
    "ImageDetails.SearchBox.placeholder": "Search",
    "ImageDetails.Sidebar.variants": "Variants",
    "ImageDetails.Software.showMore": "Show more",
    "ImageDetails.Software.showLess": "Show less",
    "ImageDetails.TagList.aliasTooltip": "Other tag name(s) for the image",
    "ImageDetails.TagList.headerName": "TAG",
    "ImageDetails.TagList.headerAlias": "ALIAS",
    "ImageDetails.TagList.headerInstalledSoftware": "INSTALLED SOFTWARE",
    "ImageDetails.TagList.headerSize": "SIZE",
    "ImageDetails.TagList.headerLastUpdated": "LAST MODIFIED",
    "ImageDetails.TagList.lastModifiedOn": "Last modified on",
    "ImageDetails.TagList.none": "none",
    "ImageDetails.TagList.size": "Size",
    "ImageDetails.TagList.showMore": "Show more",
    "ImageDetails.TagList.software": "Software",
    "ImageList.SearchBox.placeholder": "Search Images",
    "ImageList.SearchResults.headerImageName": "IMAGE NAME",
    "ImageList.SearchResults.headerDescription": "DESCRIPTION",
    "ImageList.SearchResults.headerLatestVersion": "LATEST VERSION",
    "ImageList.SearchResults.headerNumTags": "NO. OF TAGS",
    "ImageList.SearchResults.showMore": "Show more",
    "ImageList.ImageTypeSelect.machine.name": "Machine Images",
    "ImageList.ImageTypeSelect.machine.description": "Use these images in your configuration to match the virtual machine required for your specific job.",
    "ImageList.ImageTypeSelect.docker.name": "Convenience Images",
    "ImageList.ImageTypeSelect.docker.description": "Use CircleCI’s pre-built Docker images for faster spin-up times and improved reliability",
    "learnCircleCI.title": "Learn CircleCI",
    "tabs.gettingStarted": "Getting Started",
    "tabs.configuration": "Configuration",
    "tabs.tools": "Tools",
    "tabs.whatsNew": "What's New",
    "tabs.aiProjects": "AI projects",
    "gettingStartedCards.card1.iconName": "onboarding",
    "gettingStartedCards.card1.title": "5-minute quickstart guide",
    "gettingStartedCards.card1.description": "A step-by-step guide to set up your first CircleCI project, in minutes.",
    "gettingStartedCards.card1.category": "onboarding",
    "gettingStartedCards.card1.link": "https://circleci.com/docs/getting-started",
    "gettingStartedCards.card2.iconName": "learning",
    "gettingStartedCards.card2.title": "Free on-demand courses",
    "gettingStartedCards.card2.description": "We recommend new users start with our General Developer Training course.",
    "gettingStartedCards.card2.category": "learning",
    "gettingStartedCards.card2.link": "https://circleci.com/training/",
    "gettingStartedCards.card3.iconName": "howto",
    "gettingStartedCards.card3.title": "Language guides",
    "gettingStartedCards.card3.description": "Find examples based on your favorite programming language.",
    "gettingStartedCards.card3.category": "how to",
    "gettingStartedCards.card3.link": "https://circleci.com/docs/examples-and-guides-overview",
    "configurationCards.card1.iconName": "onboarding",
    "configurationCards.card1.title": "Configuration introduction",
    "configurationCards.card1.description": "Follow this guide to learn about the core of the CircleCI experience - config.yml.",
    "configurationCards.card1.category": "onboarding",
    "configurationCards.card1.link": "https://circleci.com/docs/config-intro",
    "configurationCards.card2.iconName": "reference",
    "configurationCards.card2.title": "Sample configurations",
    "configurationCards.card2.description": "Don’t start from scratch. Copy and paste a sample .circleci/config.yml file.",
    "configurationCards.card2.category": "samples",
    "configurationCards.card2.link": "https://circleci.com/docs/sample-config",
    "configurationCards.card3.iconName": "samples",
    "configurationCards.card3.title": "Configuration reference",
    "configurationCards.card3.description": "Find a full config.yml example and a list of all configuration keys.",
    "configurationCards.card3.category": "reference",
    "configurationCards.card3.link": "https://circleci.com/docs/configuration-reference",
    "toolsCards.card1.iconName": "orbs",
    "toolsCards.card1.title": "Orbs introduction",
    "toolsCards.card1.description": "Learn how orbs can help your team automate code and integrate quickly.",
    "toolsCards.card1.category": "orbs",
    "toolsCards.card1.link": "https://circleci.com/docs/orb-intro",
    "toolsCards.card2.iconName": "vscode",
    "toolsCards.card2.title": "CircleCI VS Code extension",
    "toolsCards.card2.description": "Manage your pipelines and get help writing config. in the IDE.",
    "toolsCards.card2.category": "tools",
    "toolsCards.card2.link": "https://circleci.com/product/vscode-extension/",
    "toolsCards.card3.iconName": "reference",
    "toolsCards.card3.title": "CircleCI Command Line Interface",
    "toolsCards.card3.description": "Access advanced tools through the local terminal.",
    "toolsCards.card3.category": "tools",
    "toolsCards.card3.link": "https://circleci.com/docs/local-cli/",
    "whatsNewCards.card1.iconName": "releases",
    "whatsNewCards.card1.title": "Releases UI in open preview",
    "whatsNewCards.card1.description": "View and manage your releases from a single dashboard.",
    "whatsNewCards.card1.category": "feature",
    "whatsNewCards.card1.link": "https://circleci.com/docs/release/releases-overview/",
    "whatsNewCards.card2.iconName": "config-policies",
    "whatsNewCards.card2.title": "Config policies soft fails",
    "whatsNewCards.card2.description": "Improved visibility of config policies with soft fail notifications now on the pipelines dashboard.",
    "whatsNewCards.card2.category": "feature",
    "whatsNewCards.card2.link": "https://circleci.com/changelog/config-policies-soft-fails-ui/",
    "whatsNewCards.card3.iconName": "trigger",
    "whatsNewCards.card3.title": "Inbound webhooks",
    "whatsNewCards.card3.description": "Trigger pipelines from anywhere that can emit a webhook or curl command.",
    "whatsNewCards.card3.category": "feature",
    "whatsNewCards.card3.link": "https://discuss.circleci.com/t/trigger-pipelines-from-anywhere-inbound-webhooks-now-in-preview/49864",
    "aiProjectsCards.card1.iconName": "sagemaker",
    "aiProjectsCards.card1.title": "Orchestrate model deployment",
    "aiProjectsCards.card1.description": "The new Amazon SageMaker orb ensures zero downtime releases across environments.",
    "aiProjectsCards.card1.category": "How to",
    "aiProjectsCards.card1.link": "https://circleci.com/docs/deploy-to-amazon-sagemaker/",
    "aiProjectsCards.card2.iconName": "webhooks",
    "aiProjectsCards.card2.title": "Integrate your AI pipelines",
    "aiProjectsCards.card2.description": "Trigger CI pipelines on model, dataset and prompt changes with inbound webhooks.",
    "aiProjectsCards.card2.category": "How to",
    "aiProjectsCards.card2.link": "https://circleci.com/blog/mlops-trigger-inbound-webhooks/",
    "aiProjectsCards.card3.iconName": "llm",
    "aiProjectsCards.card3.title": "Test non-deterministic features",
    "aiProjectsCards.card3.description": "Find out how to automate evaluation of LLM-based applications in your CI pipeline.",
    "aiProjectsCards.card3.category": "Learning",
    "aiProjectsCards.card3.link": "https://circleci.com/blog/deploy-reevaluate-llm-langsmith/",
    "newsletterSignup.heading": "Developer Updates",
    "newsletterSignup.subheading": "Get tips to optimize your builds",
    "newsletterSignup.joinPanel": "Or <join>join our research panel</join> and give feedback",
    "newsletterSignup.button": "Subscribe",
    "newsletterSignup.email": "Email Address",
    "newsletterSignup.country": "Country",
    "newsletterSignup.allFieldsRequired": "All fields required. ",
    "newsletterSignup.terms": "By submitting this form, you are agreeing to our<terms>Terms of Use</terms>and<privacy>Privacy Policy</privacy>.",
    "newsletterSignup.termsLink": "https://circleci.com/legal/terms-of-use/",
    "newsletterSignup.privacyLink": "https://circleci.com/privacy/",
    "newsletterSignup.joinLink": "https://circleci.com/research/",
    "newsletterSignup.success": "Successfully subscribed.",
    "newsletterSignup.error": "Something went wrong, check your inputs.",
    "OrbDetails.OrbStatusBadge.certified": "Certified",
    "OrbDetails.OrbStatusBadge.partner": "Partner",
    "OrbDetails.OrbStatusBadge.private": "Private",
    "OrbDetails.OrbShowHeader.categories": "Categories:",
    "OrbDetails.OrbShowHeader.homepage": "Homepage:",
    "OrbDetails.OrbShowHeader.orbCreated": "Created:",
    "OrbDetails.OrbShowHeader.orgUsage": "Org Usage:",
    "OrbDetails.OrbShowHeader.orgUsageTooltip": "Number of organizations that have used an orb in the past 30 days",
    "OrbDetails.OrbShowHeader.releases": "Releases:",
    "OrbDetails.OrbShowHeader.source": "Source:",
    "OrbDetails.OrbShowHeader.versionPublished": "Version Published:",
    "OrbDetails.OrbShowHeader.licensing": "See Orb Licensing",
    "OrbDetails.OrbShowHeader.reportOrb": "Report this Orb",
    "OrbDetails.OrbShowLayout.commands": "Commands",
    "OrbDetails.OrbShowLayout.executors": "Executors",
    "OrbDetails.OrbShowLayout.jobs": "Jobs",
    "OrbDetails.OrbShow.title": "CircleCI Developer Hub - {orbFullName}",
    "OrbDetails.OrbShow.copyCode": "Copy This Code",
    "OrbDetails.OrbShow.formattedDefaultValue": "[sequence of length {length}] see source",
    "OrbDetails.OrbShow.licenseSource": "# This code is licensed from CircleCI to the user under the MIT license.\n# See here for details: ",
    "OrbDetails.OrbShow.orbsBreadcrumb": "Orbs",
    "OrbDetails.OrbShow.orbSource": "Orb Source",
    "OrbDetails.OrbShow.parameterTableHeaderName": "PARAMETER",
    "OrbDetails.OrbShow.parameterTableHeaderDescription": "DESCRIPTION",
    "OrbDetails.OrbShow.parameterTableHeaderRequired": "REQUIRED",
    "OrbDetails.OrbShow.parameterTableHeaderDefault": "DEFAULT",
    "OrbDetails.OrbShow.parameterTableHeaderType": "TYPE",
    "OrbDetails.OrbShow.parameterType": "type: {type}",
    "OrbDetails.OrbShow.quickStartGuide": "Orb Quick Start Guide",
    "OrbDetails.OrbShow.quickStartStep1A": "Use CircleCI version 2.1 at the top of your .circleci/config.yml file.",
    "OrbDetails.OrbShow.quickStartStep2": "Add the <code>orbs</code> stanza below your version, invoking the orb:",
    "OrbDetails.OrbShow.quickStartStep3": "Use <code>{orbName}</code> elements in your existing workflows and jobs.",
    "OrbDetails.OrbShow.quickStartCertifiedStep1A": "Opt-in to use of uncertified orbs on your organization’s Security settings page.",
    "OrbDetails.OrbShow.quickStartCertifiedStep1B": "Read more in the docs here.",
    "OrbDetails.OrbShow.required": "Required",
    "OrbDetails.OrbShow.sideBarQuickStartGuide": "Orb Quick Start Guide",
    "OrbDetails.OrbShow.sideBarUsageExamples": "Usage Examples",
    "OrbDetails.OrbShow.sideBarOrbSource": "Orb Source",
    "OrbDetails.OrbShow.sourceHide": " Hide ",
    "OrbDetails.OrbShow.sourceShow": " Show ",
    "OrbDetails.OrbShow.source": " Source",
    "OrbDetails.OrbShow.usageExamples": "Usage Examples",
    "OrbDetails.OrbShow.yes": "Yes",
    "OrbDetails.OrbShow.no": "No",
    "OrbList.DropdownBadgeTypeFilters.all": "All",
    "OrbList.DropdownBadgeTypeFilters.certifiedAndPartner": "Certified and Partner",
    "OrbList.DropdownBadgeTypeFilters.popular": "Popular",
    "OrbList.CategoryFilters.placeholder": "Select",
    "OrbList.OrbList.searchBoxHeader": "Search Orbs",
    "OrbList.OrbList.typeFilterHeader": "Filter by Orb Type",
    "OrbList.OrbList.categoryFilterHeader": "Select Categories",
    "OrbList.OrbList.tooltip": "Certified and Partner: orbs written and tested by the CircleCI team and our technology partners\nPopular: orbs used by 3 or more organizations",
    "OrbList.PageNavigation.results": "Results: {start}-{end} of {numResults}",
    "OrbList.SearchBox.placeholder": "Search",
    "OrbList.SearchResults.headerName": "NAME",
    "OrbList.SearchResults.headerDescription": "DESCRIPTION",
    "OrbList.SearchResults.headerLastModified": "LAST MODIFIED",
    "OrbList.SearchResults.headerOrgUsage": "ORG USAGE",
    "OrbList.SearchResults.lastModifiedOn": "Last modified on",
    "OrbList.SearchResults.orgUsage": "Org usage",
    "OrbList.SearchResults.orgUsageTooltip": "Number of organizations that have used an orb in the past 30 days",
    "OrbList.SearchResults.showMore": "Show more",
    "orbs_insights.orbs.title": "Orbs: reusable configuration",
    "orbs_insights.orbs.featureDescription": "Automate your manual tasks",
    "orbs_insights.orbs.content": "Orbs are CircleCI’s package manager. They’re shareable across teams, making it easy to keep your configuration up-to-date and in-sync.",
    "orbs_insights.orbs.badgeHeading": "POPULAR ORBS",
    "orbs_insights.insights.title": "Insights: performance metrics",
    "orbs_insights.insights.featureDescription": "Save time and money",
    "orbs_insights.insights.content": "Use the CircleCI Insights dashboard to evaluate the overall health of your pipelines and find ways to speed up builds.",
    "orbs_insights.insights.badgeHeading": "MONITOR SPEED AND SPEND",
    "shared.MobileSectionsNavContainer.sections": "Sections",
    "shared.SearchStatusIndicator.searchStatusError": "We're sorry! An error ocurred while performing the search.",
    "shared.SearchStatusIndicator.searchStatusNoResults": "We're sorry! We cannot find any matching results for your search term.",
    "shared.orbSearch.noResultsMessage1": "We're sorry! We cannot find any matching orbs for your search term. Why don't you try <create>creating an orb</create> with that functionality?",
    "shared.orbSearch.noResultsLink": "https://circleci.com/docs/creating-orbs",
    "shared.orbSearch.errorMessage": "Error fetching orbs. Refresh the page to try again.",
    "shared.FormattedCode.copy": "Copy",
    "links.external.home": "https://circleci.com/",
    "links.external.docs": "https://circleci.com/docs/",
    "links.external.imageDocs": "https://circleci.com/docs/circleci-images",
    "links.external.machineDocs": "https://circleci.com/docs/executor-types?section=executors-and-images#using-machine",
    "links.external.privateOrb": "https://circleci.com/docs/orb-intro",
    "links.external.orbDocs": "https://circleci.com/docs/orb-intro",
    "links.external.signup": "https://www.circleci.com/signup",
    "links.external.vcs-authorize": "https://circleci.com/vcs-authorize",
    "links.social.blogFeed": "https://circleci.com/blog/feed.xml",
    "links.social.facebook": "https://www.facebook.com/circleci",
    "links.social.twitter": "https://twitter.com/circleci",
    "links.social.linkedIn": "https://www.linkedin.com/company/circleci",
    "links.social.github": "https://github.com/circleci",
    "links.external.termsOfUse": "https://circleci.com/legal/terms-of-use/",
    "links.external.privacyPolicy": "https://circleci.com/privacy/",
    "links.external.cookiePolicy": "https://circleci.com/legal/cookie-policy/",
    "links.external.security": "https://circleci.com/security/",
    "links.external.pricing": "https://circleci.com/pricing/",
    "links.external.getStarted": "https://circleci.com/docs/getting-started/",
    "links.external.signUp": "https://circleci.com/signup/",
    "links.external.quickstartGuide": "https://circleci.com/docs/getting-started/",
    "links.external.onDemandCourse": "https://circleci.com/training/",
    "links.external.examplesGuides": "https://circleci.com/docs/examples-and-guides-overview/",
    "links.external.configIntro": "https://circleci.com/docs/config-intro/",
    "links.external.sampleConfig": "https://circleci.com/docs/sample-config/",
    "links.external.configReference": "https://circleci.com/docs/configuration-reference/",
    "links.external.orbsIntro": "https://circleci.com/docs/orb-intro/",
    "links.internal.nodeOrb": "https://circleci.com/developer/orbs/orb/circleci/node/",
    "links.internal.androidImage": "https://circleci.com/developer/images/image/cimg/android/",
    "links.external.tokens": "https://circleci.com/docs/openid-connect-tokens/",
    "links.external.macOS": "https://circleci.com/changelog/#new-macos-cloud-ips/",
    "links.external.IP": "https://circleci.com/docs/ip-ranges/#circleci-macos-cloud/",
    "links.internal.orbFeature": "/orbs",
    "links.internal.slack": "/orbs/orb/circleci/slack/",
    "links.internal.aws": "/orbs?query=aws&page=1&pageSize=15&filterBy=certifiedAndPartner/",
    "links.internal.node": "/orbs/orb/circleci/node/",
    "links.external.insightsFeatureLoggedIn": "https://app.circleci.com/insights/",
    "links.external.insightsFeatureLoggedOut": "https://circleci.com/docs/insights/",
    "links.external.responseTime": "https://circleci.com/docs/optimizations/",
    "links.external.credits": "https://circleci.com/docs/insights-glossary/?highlight#organization-level-metrics/",
    "links.external.tests": "https://circleci.com/docs/test-splitting-tutorial/",
    "links.external.newFeatures": "https://circleci.com/changelog/",
    "links.external.integrations": "https://circleci.com/integrations/",
    "links.external.languageGuides": "https://circleci.com/docs/examples-and-guides-overview/",
    "links.external.webhooks": "https://circleci.com/docs/webhooks/",
    "indexPage.title": "CircleCI Developer Hub",
    "indexPage.pageDescription": "Developer Home",
    "indexPage.metaDescription": "CircleCI Developer Hub provides Docker images (convenience images), configuration packages (orbs), documentation, API, CLI and other tools and resources.",
    "gettingStarted.heading": "Getting Started",
    "gettingStarted.subhead": "Learn <ci>the basics</ci> of CI/CD and <about>how CircleCI works</about>. Take a step-by-step approach to setting up your first project on CircleCI.",
    "gettingStarted.subheadCILink": "https://circleci.com/continuous-integration/",
    "gettingStarted.subheadAboutLink": "https://circleci.com/docs/about-circleci#section=welcome",
    "gettingStarted.cta1Text": "Hello World",
    "gettingStarted.cta1Link": "https://circleci.com/docs/hello-world#section=getting-started",
    "gettingStarted.cta2Text": "Step-by-Step Tutorial",
    "gettingStarted.cta2Link": "https://circleci.com/docs/getting-started#section=getting-started",
    "config.heading": "CircleCI Configuration",
    "config.subhead": "Our configuration-as-code philosophy means the entire delivery process, from build to deploy, is orchestrated through a single file called config.yml. Learn CircleCI’s pipeline hierarchy and how to successfully set-up your YAML file.",
    "config.cta1Text": "Explore the Configuration",
    "config.cta1Link": "https://circleci.com/docs/config-intro#section=configuration",
    "config.migrationGuides": "Migration Guides for Other CI Tools",
    "config.migrationGuidesLink": "https://circleci.com/docs/migration-intro#section=getting-started",
    "config.jenkinsfileConverter": "Jenkinsfile Converter",
    "config.tipsForOptimizing": "Tips for Optimizing Configuration",
    "config.tipsForOptimizingLink": "https://circleci.com/blog/six-optimization-tips-for-your-config/",
    "orbs.heading": "CircleCI Orbs",
    "orbs.subhead": "Orbs are reusable packages of configuration that simplify your development process. Choose from thousands of orbs available on our <orbs>public registry</orbs>, or take advantage of our <plans>paid plans</plans> and create private orbs used exclusively by your organization.",
    "orbs.cta1Text": "Explore Orbs",
    "orbs.learnMore": "Learn More",
    "orbs.learnMoreLink": "https://circleci.com/orbs/",
    "orbs.exploreDocs": "Explore Docs",
    "orbs.exploreDocsLink": "https://circleci.com/docs/orb-intro#section=configuration",
    "featuredOrb.link": "/orbs/orb/circleci/node",
    "featuredOrb.heading": "Featured Orb: Node",
    "featuredOrb.name": "Node.js",
    "featuredOrb.description": "Easily install Node.js and its package managers (npm, yarn). Best of all, install your packages with caching enabled by default.",
    "featuredOrb.namespace": "circleci/node",
    "featuredOrb.label": "Certified",
    "featuredOrb.seeAll": "See All Orbs",
    "images.heading": "Convenience Images for Docker",
    "images.subhead": "CircleCI maintains a fleet of Docker images for a CI/CD environment that are compatible with multiple programming languages and a few databases. Use images as a quick and convenient starting point for your containerized environment.",
    "images.exploreImages": "Explore Images",
    "images.dockerBasics": "Docker Basics Tutorial",
    "images.dockerBasicsLink": "https://circleci.com/blog/docker-and-cicd-tutorial-a-deep-dive-into-containers/",
    "images.viewDocs": "View Docs",
    "images.viewDocsLink": "https://circleci.com/docs/executor-intro#section=configuration",
    "machine.heading": "Machine Images for CircleCI",
    "machine.subhead": "CircleCI maintains a fleet of Docker images for a CI/CD environment that are compatible with multiple programming languages and a few databases. Use images as a quick and convenient starting point for your containerized environment.",
    "machine.exploreImages": "Explore Images",
    "machine.machineBasics": "Machine Basics Tutorial",
    "machine.dockerBasicsLink": "https://circleci.com/blog/docker-and-cicd-tutorial-a-deep-dive-into-containers/",
    "machine.viewDocs": "View Docs",
    "machine.viewDocsLink": "https://circleci.com/docs/executor-intro#section=configuration",
    "featuredImage.link": "/images/image/cimg/node",
    "featuredImage.heading": "Featured Image: cimg/node",
    "featuredImage.name": "cimg/node",
    "featuredImage.description1": "Each tag contains a version of Node.js, ",
    "featuredImage.description2": "npm",
    "featuredImage.description3": ", ",
    "featuredImage.description4": "yarn v1",
    "featuredImage.description5": ", and any binaries and tools that are required for builds to complete successfully in a CircleCI environment.",
    "featuredImage.versionLabel": "Latest version: ",
    "featuredImage.seeAll": "See All Images",
    "integrations.heading": "Integrations and Interfaces",
    "integrations.subhead": "Integrate your existing toolchain to stay productive and in-flow using orbs, our API and CLI, and CircleCI webhooks.",
    "integrations.cta1Text": "Explore CircleCI Integrations",
    "integrations.cta1Link": "https://circleci.com/integrations/",
    "integrations.cta2Text": "View Certified and Partner Orbs",
    "webhooks.heading": "Webhooks",
    "webhooks.subhead": "CircleCI webhooks enable developers to create customizable integrations with workflow-level and job-level events.",
    "webhooks.cta1Text": "Explore Webhooks",
    "webhooks.cta1Link": "https://circleci.com/docs/webhooks",
    "api.heading": "API",
    "api.subhead": "Create tools to automate actions within applications or systems.",
    "api.cta1Text": "Explore the API",
    "api.cta1Link": "https://circleci.com/docs/api/v2/#circleci-api",
    "cli.heading": "Command Line Interface",
    "cli.subhead": "Install the CLI to leverage our advanced tools through your own terminal.",
    "cli.cta1Text": "Explore the CLI",
    "cli.cta1Link": "https://circleci.com/docs/local-cli",
    "cli.install": "Install the CLI",
    "cli.installLink": "https://github.com/CircleCI-Public/circleci-cli",
    "resources.heading": "Resources",
    "resources.subhead": "Setting up your CI/CD pipelines and maintaining an efficient practice shouldn’t be done in silos. Take advantage of resources and best practices from in-house experts and our community.",
    "docs.heading": "Documentation",
    "docs.subhead": "Whether you’re new to CI/CD or an experienced developer, use the tutorials, samples, and how-to guides in our documentation to learn CircleCI.",
    "docs.cta1Text": "Explore Docs",
    "docs.cta1Link": "https://circleci.com/docs/",
    "docs.helloWorld": "Hello World",
    "docs.helloWorldLink": "https://circleci.com/docs/hello-world#section=getting-started",
    "learning.heading": "Learning Resources",
    "learning.subhead": "Access the CircleCI Academy for free, developer-led training or view technical tutorials and perspectives on our blog. Learn from our team of experts and customize your onboarding experience.",
    "learning.cta1Text": "Explore CircleCI Academy",
    "learning.cta1Link": "https://circleci.com/training/",
    "learning.blogTutorials": "View Blog Tutorials",
    "learning.blogTutorialsLink": "https://circleci.com/blog/tag/tutorials/",
    "learning.webinars": "Watch Recent Webinars",
    "learning.webinarsLink": "https://www.youtube.com/playlist?list=PL9GgS3TcDh8yzDPyWHcBzZg0KetWB1hMY",
    "community.heading": "Community & Support",
    "community.subhead": "Get the support you need from CircleCI and our growing community of more than 600K developers.",
    "community.cta1Text": "Explore Community Forum",
    "community.cta1Link": "https://discuss.circleci.com/",
    "community.premiumSupport": "Explore Premium Support",
    "community.premiumSupportLink": "https://circleci.com/support/premium-support/",
    "community.expert": "Get Support",
    "community.expertLink": "https://support.circleci.com/hc/en-us",
    "imagesPage.title": "CircleCI Developer - Images",
    "imagesPage.pageDescription": "Images",
    "imagesPage.shortDescription": "CircleCI maintains a fleet of images for various programming languages, databases, and operating systems.",
    "imagesPage.metaDescription": "CircleCI maintains a fleet of images for various programming languages, databases, and operating systems.",
    "imagesPage.docsLinkText": "Read documentation",
    "imagePage.title": "{imageName} - CircleCI",
    "imagePage.imagesBreadcrumb": "Convenience Images",
    "machinePage.title": "CircleCI Developer - Machine Images{imageName} - CircleCI",
    "machinePage.pageDescription": "Machine Images",
    "machinePage.shortDescription": "Use these images in your configuration to match the virtual machine required for your specific job.",
    "machinePage.metaDescription": "Use these images in your configuration to match the virtual machine required for your specific job.",
    "machinePage.docsLinkText": "Read documentation",
    "machinePage.machineBreadcrumb": "Machine Images",
    "orbsPage.title": "CircleCI Developer - Orbs",
    "orbsPage.pageDescription": "Orbs",
    "orbsPage.shortDescription": "Orbs are shareable packages of CircleCI configuration you can use to simplify your builds. Choose from the many partner, community, or CircleCI authored orbs in our public registry below, or create a <link>private orb</link> that’s exclusive to your organization.",
    "orbsPage.metaDescription": "Condense commands, executors, and jobs into single, reusable code.  Orbs can automate repeated processes, speed up setups, and allow for easier integration.",
    "orbsPage.docsLinkText": "Read documentation",
    "orbsPage.orbDelay.title": "Newly published orbs",
    "orbsPage.orbDelay.content": "may not appear on this page for up to 30 minutes.",
    "orbsLicensing.title": "CircleCI Developer - Orb Licensing",
    "orbsLicensing.pageDescription": "Orb Licensing",
    "orbsLicensing.metaDescription": "Orbs authors agree to the CircleCI Code Sharing Terms of Service when their organizations opt-in to 3rd party orb use and authoring.",
    "orbsLicensing.orbLicense.subHeader": "Orbs License",
    "orbsLicensing.orbLicense.subDetail1": "Orbs authors agree to our ",
    "orbsLicensing.orbLicense.tosInlineLink": "https://circleci.com/legal/code-sharing-terms/",
    "orbsLicensing.orbLicense.tosInlineText": "Code Sharing Terms of Service ",
    "orbsLicensing.orbLicense.subDetail2": "when their organizations opt-in to 3rd party orb use and authoring. CircleCI thereby licenses all orbs back to users under the ",
    "orbsLicensing.orbLicense.mitInlineLink": "https://opensource.org/licenses/MIT",
    "orbsLicensing.orbLicense.mitInlineText": "MIT License agreement.",
    "orbsLicensing.orbMitLicense.subHeader": "Official MIT License Terms",
    "orbsLicensing.orbMitLicense.subDetail1": "Copyright 2020 Circle Internet Services, Inc.",
    "orbsLicensing.orbMitLicense.subDetail2": "Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the \"Software\"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:",
    "orbsLicensing.orbMitLicense.subDetail3": "The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.",
    "orbsLicensing.orbMitLicense.subDetail4": "THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.",
    "orbPage.title": "CircleCI Developer Hub - {orbFullName}",
    "orbPage.orbsBreadcrumb": "Orbs",
    "orbsReport.title": "CircleCI Developer - Reporting an Orb",
    "orbsReport.pageDescription": "Reporting an Orb",
    "orbsReport.metaDescription": "Steps to report a CircleCI Orb for any malicious behavior or accidental leak of private information.",
    "orbsReport.when.header": "When should I report an orb?",
    "orbsReport.when.detail": "There are two reasons to report an orb: ",
    "orbsReport.when.detailItem1Key": "Malicious Orbs: ",
    "orbsReport.when.detailItem1Value": "The orb’s content poses a threat to the orb’s users. Examples may include an orb that mines cryptocurrency, or that uploads credentials to a malicious URL.",
    "orbsReport.when.detailItem2Key": "Accidental Leakage of Private Data: ",
    "orbsReport.when.detailItem2Value": "The orb’s content poses a threat to the orb author. For example, a user might have hardcoded AWS keys inside their orb during development, and forgotten to remove it when they published the orb.",
    "orbsReport.what.header": "What happens after I report an orb?",
    "orbsReport.what.detail1": "Your orb report will be reviewed by the CircleCI security team as soon as possible, and responded to in due course.",
    "orbsReport.what.detail2": "Malicious orbs will be removed immediately.",
    "orbsReport.what.detail3": "Orbs accidentally leaking private data will be weighed by the potential harm to the orb’s users (from breaking their builds, or transitively removing the orbs they’ve authored) and the harm to the orb’s author.",
    "orbsReport.what.detail4": "In case of the latter, it’s important to note that once the orb is published, it is public. CircleCI has no way to determine whether a third party has accessed the orb, however briefly it was published. A user who has published a credential or other secret into an orb should consider themselves compromised and start rolling credentials.",
    "orbsReport.how.header": "How do I report an orb? ",
    "orbsReport.how.detail1": "Contact our security team by following the instructions here (including use of encryption keys if you are reporting a serious security vulnerability): ",
    "orbsReport.how.securityLink": "https://circleci.com/security/",
    "orbsReport.how.detail2": "It’s helpful to include a link to the orb you’re reporting and some details about why this orb qualifies for review."
  },
  "ja": {
    "Header.AppName.name": "デベロッパー",
    "Header.Header.linkCircleCIHome": "circleci.com",
    "Header.Header.linkDocumentation": "ドキュメント",
    "Header.HeaderNavTabs.devhub": "ホーム",
    "Header.HeaderNavTabs.docs": "ドキュメント",
    "Header.HeaderNavTabs.images": "イメージ",
    "Header.HeaderNavTabs.orbs": "Orbs",
    "Header.HeaderNavTabs.jfc": "コンバーター",
    "Header.SignupButton.loggedOutLabel": "登録",
    "Header.SignupButton.loggedInLabel": "アプリへ移動",
    "Header.SignupButton.login": "ログイン",
    "Header.ImageTypes.machine.name": "コンビニエンス イメージ",
    "Header.ImageTypes.machine.body": "これらのイメージを活用して、特定のジョブに必要な仮想マシン (VM) に合わせて構成しましょう。",
    "Header.ImageTypes.docker.name": "コンビニエンス イメージ",
    "Header.ImageTypes.docker.body": "スピンアップ速度も信頼性も高められる、CircleCI 特製のビルド済み Docker イメージをご活用ください。",
    "Banner.private-orbs.lede": "新機能",
    "Banner.private-orbs.body": "CircleCI Scale プランでプライベート Orbs を利用可能に<cta>詳細はこちら</cta>",
    "Banner.private-orbs.ctaLink": "https://circleci.com/ja/blog/circleci-private-orbs/",
    "Banner.dedicated-hosts-macos.lede": "New",
    "Banner.dedicated-hosts-macos.body": "すべての有料プランで、macOS ビルド向けの専用ホストが利用可能になりました。 <cta>詳しく見る</cta> ",
    "Banner.dedicated-hosts-macos.ctaLink": "https://circleci.com/docs/ja/2.0/dedicated-hosts-macos/",
    "Banner.sosd-2022.lede": "新レポート",
    "Banner.sosd-2022.body": "『2022 年版ソフトウェアデリバリーに関する現状調査』レポートで、一流チームになるためのツールや手法を身につけましょう。<cta>レポートを読む</cta>",
    "Banner.sosd-2022.ctaLink": "https://www2.circleci.com/ja-2022-state-of-software-delivery.html",
    "Banner.ubuntu-deprecation.lede": "メンテナンス",
    "Banner.ubuntu-deprecation.body": "Ubuntu 14.04 および 16.04 イメージ提供終了: これらのイメージについては、2022 年 3 月 29 日と 4 月 26 日に提供を一時中断した後、5 月 31 日をもって完全に提供を終了いたします。<cta>詳しくはこちら</cta>",
    "Banner.ubuntu-deprecation.ctaLink": "https://circleci.com/ja/blog/ubuntu-14-16-image-deprecation/",
    "Banner.xcode-support-macos.lede": "お知らせ",
    "Banner.xcode-support-macos.body": "Xcode 14.2.0は、macOSのmediumとlargeリソースクラスによってサポートされる最後のXcodeバージョンです。3 月中旬から、Free プランのお客様は Gen2 macOS リソースにアップグレードされます。<cta>さらに詳しく/cta>",
    "Banner.xcode-support-macos.ctaLink": "https://discuss.circleci.com/t/macos/47186",
    "Banner.pipelines-maintenance.lede": "メンテナンスのお知らせ",
    "Banner.pipelines-maintenance.body": "CircleCI の定期メンテナンスは、2023年8月12日16:00-17:00 UTCから2023年9月23日16:00-17:00 UTCに変更されました。<cta>詳細はこちら</cta>",
    "Banner.pipelines-maintenance.ctaLink": "https://discuss.circleci.com/t/2023-9-23-4-5-utc-24-1/48716",
    "Banner.close": "バナーを閉じる",
    "helpfulResources.title": "関連資料",
    "helpfulResources.newFeatures.title": "新機能",
    "helpfulResources.newFeatures.description": "CircleCI の更新履歴はこちら。CI の最新情報をご確認ください。",
    "helpfulResources.newFeatures.category": "new",
    "helpfulResources.integrations.title": "インテグレーション",
    "helpfulResources.integrations.description": "Orb や API を使用して DevOps プロセスを統合しましょう。",
    "helpfulResources.integrations.category": "integrations",
    "helpfulResources.langGuides.title": "言語ガイド",
    "helpfulResources.langGuides.description": "アプリ構築のための言語とフレームワークに関するガイドをご覧いただけます。",
    "helpfulResources.langGuides.category": "guides",
    "helpfulResources.webhooks.title": "Webhook",
    "helpfulResources.webhooks.description": "ワークフローやジョブのイベントとのカスタム可能なインテグレーションを構築しましょう。",
    "helpfulResources.webhooks.category": "integrations",
    "hero.heading_new": "CircleCI へようこそ",
    "hero.subhead_new": "CircleCI は、ソフトウェアをより迅速にリリースしたいチームのためのソフトウェアデリバリーエンジンです。再利用可能でメンテナンスが簡単なコードを使って設定いただけます。",
    "hero.getting_started_btn_new": "はじめよう",
    "hero.sign_up_free_btn_new": "無料でユーザー登録",
    "hero.platform_action_button": "アプリへ移動",
    "hero.heading": "CI/CD パイプラインの最適化に必要なものがすべて揃っています",
    "hero.subhead": "CircleCI の構成パッケージ (CircleCI Orbs)、ドキュメント、API、CLI、各種ツールやリソースにアクセスできます。",
    "ImageDetails.SearchBox.placeholder": "検索",
    "ImageDetails.Sidebar.variants": "バリアント",
    "ImageDetails.Software.showMore": "表示を増やす",
    "ImageDetails.Software.showLess": "表示を減らす",
    "ImageDetails.TagList.aliasTooltip": "イメージ タグの別名",
    "ImageDetails.TagList.headerName": "タグ",
    "ImageDetails.TagList.headerAlias": "エイリアス",
    "ImageDetails.TagList.headerInstalledSoftware": "収録内容",
    "ImageDetails.TagList.headerSize": "サイズ",
    "ImageDetails.TagList.headerLastUpdated": "最終更新日",
    "ImageDetails.TagList.lastModifiedOn": "Last modified on",
    "ImageDetails.TagList.none": "なし",
    "ImageDetails.TagList.size": "サイズ",
    "ImageDetails.TagList.showMore": "表示を増やす",
    "ImageDetails.TagList.software": "Software",
    "ImageList.SearchBox.placeholder": "イメージ検索",
    "ImageList.SearchResults.headerImageName": "イメージ名",
    "ImageList.SearchResults.headerDescription": "説明",
    "ImageList.SearchResults.headerLatestVersion": "最新バージョン",
    "ImageList.SearchResults.headerNumTags": "NO. OF TAGS",
    "ImageList.SearchResults.showMore": "Show more",
    "ImageList.ImageTypeSelect.machine.name": "Machine Images",
    "ImageList.ImageTypeSelect.machine.description": "Use these images in your configuration to match the virtual machine required for your specific job.",
    "ImageList.ImageTypeSelect.docker.name": "Convenience Images",
    "ImageList.ImageTypeSelect.docker.description": "Use CircleCI’s pre-built Docker images for faster spin-up times and improved reliability",
    "learnCircleCI.title": "CircleCI を学ぶ",
    "tabs.gettingStarted": "入門ガイド",
    "tabs.configuration": "設定ファイル",
    "tabs.tools": "ツール",
    "tabs.whatsNew": "What's New",
    "tabs.aiProjects": "AI projects",
    "gettingStartedCards.card1.iconName": "onboarding",
    "gettingStartedCards.card1.title": "5 分でわかるクイックスタートガイド",
    "gettingStartedCards.card1.description": "初めての CircleCI プロジェクトを数分でセットアップできるステップバイステップガイドです。",
    "gettingStartedCards.card1.category": "onboarding",
    "gettingStartedCards.card1.link": "https://circleci.com/docs/ja/getting-started",
    "gettingStartedCards.card2.iconName": "learning",
    "gettingStartedCards.card2.title": "無料のオンデマンドトレーニング",
    "gettingStartedCards.card2.description": "初めてご利用になる方は、General Developer Training Cource から始めることをお勧めします。",
    "gettingStartedCards.card2.category": "learning",
    "gettingStartedCards.card2.link": "https://circleci.com/ja/training/",
    "gettingStartedCards.card3.iconName": "howto",
    "gettingStartedCards.card3.title": "言語ガイド",
    "gettingStartedCards.card3.description": "使用したいプログラミング言語でのサンプルをお探しください。",
    "gettingStartedCards.card3.category": "how to",
    "gettingStartedCards.card3.link": "https://circleci.com/docs/ja/examples-and-guides-overview",
    "configurationCards.card1.iconName": "onboarding",
    "configurationCards.card1.title": "設定ガイド",
    "configurationCards.card1.description": "このガイドを読んで CircleCI エクスペリエンスのコアである config.yml について理解を深めて下さい。",
    "configurationCards.card1.category": "onboarding",
    "configurationCards.card1.link": "https://circleci.com/docs/ja/config-intro",
    "configurationCards.card2.iconName": "reference",
    "configurationCards.card2.title": "サンプル設定ファイル",
    "configurationCards.card2.description": "ゼロから作成せずに、.circleci/config.yml のサンプルファイルをコピー＆ペーストしましょう。",
    "configurationCards.card2.category": "samples",
    "configurationCards.card2.link": "https://circleci.com/docs/ja/sample-config",
    "configurationCards.card3.iconName": "samples",
    "configurationCards.card3.title": "設定のリファレンス",
    "configurationCards.card3.description": "config.yml のフルサンプルと全設定キーの一覧を確認できます。",
    "configurationCards.card3.category": "reference",
    "configurationCards.card3.link": "https://circleci.com/docs/ja/configuration-reference",
    "toolsCards.card1.iconName": "orbs",
    "toolsCards.card1.title": "Orb ガイド",
    "toolsCards.card1.description": "Orb によって自動化とインテグレーションがどれほど迅速化するかをご確認ください。",
    "toolsCards.card1.category": "orbs",
    "toolsCards.card1.link": "https://circleci.com/docs/ja/orb-intro",
    "toolsCards.card2.iconName": "vscode",
    "toolsCards.card2.title": "CircleCI VS Code 拡張機能",
    "toolsCards.card2.description": "IDE でパイプラインを管理し、コンフィグの書き方をサポート",
    "toolsCards.card2.category": "tools",
    "toolsCards.card2.link": "https://circleci.com/ja/product/vscode-extension/",
    "toolsCards.card3.iconName": "reference",
    "toolsCards.card3.title": "CircleCI CLI",
    "toolsCards.card3.description": "ローカルターミナルから高度なツールにアクセス",
    "toolsCards.card3.category": "tools",
    "toolsCards.card3.link": "https://circleci.com/docs/ja/local-cli/",
    "whatsNewCards.card1.iconName": "releases",
    "whatsNewCards.card1.title": "Releases UI in open preview",
    "whatsNewCards.card1.description": "View and manage your releases from a single dashboard.",
    "whatsNewCards.card1.category": "feature",
    "whatsNewCards.card1.link": "https://circleci.com/docs/ja/release/releases-overview/",
    "whatsNewCards.card2.iconName": "config-policies",
    "whatsNewCards.card2.title": "Config policies soft fails",
    "whatsNewCards.card2.description": "Improved visibility of config policies with soft fails notification now on the pipelines dashboard.",
    "whatsNewCards.card2.category": "feature",
    "whatsNewCards.card2.link": "https://circleci.com/changelog/config-policies-soft-fails-ui/",
    "whatsNewCards.card3.iconName": "trigger",
    "whatsNewCards.card3.title": "Inbound webhooks",
    "whatsNewCards.card3.description": "Trigger pipelines from anywhere that can emit a webhook or curl command.",
    "whatsNewCards.card3.category": "feature",
    "whatsNewCards.card3.link": "https://discuss.circleci.com/t/trigger-pipelines-from-anywhere-inbound-webhooks-now-in-preview/49864",
    "aiProjectsCards.card1.iconName": "sagemaker",
    "aiProjectsCards.card1.title": "Orchestrate model deployment",
    "aiProjectsCards.card1.description": "The new Amazon SageMaker orb ensures zero downtime releases across environments.",
    "aiProjectsCards.card1.category": "How to",
    "aiProjectsCards.card1.link": "https://circleci.com/docs/deploy-to-amazon-sagemaker/",
    "aiProjectsCards.card2.iconName": "webhooks",
    "aiProjectsCards.card2.title": "Integrate your AI pipelines",
    "aiProjectsCards.card2.description": "Trigger CI pipelines on model, dataset and prompt changes with inbound webhooks",
    "aiProjectsCards.card2.category": "How to",
    "aiProjectsCards.card2.link": "https://circleci.com/blog/mlops-trigger-inbound-webhooks/",
    "aiProjectsCards.card3.iconName": "llm",
    "aiProjectsCards.card3.title": "Test non-deterministic features",
    "aiProjectsCards.card3.description": "Find out how to automate evaluation of LLM-based applications in your CI pipeline.",
    "aiProjectsCards.card3.category": "Learning",
    "aiProjectsCards.card3.link": "https://circleci.com/blog/deploy-reevaluate-llm-langsmith/",
    "newsletterSignup.heading": "開発者向け最新情報",
    "newsletterSignup.subheading": "ビルド最適化のためのヒントを手に入れましょう。",
    "newsletterSignup.joinPanel": "または、<join>リサーチパネルに参加して</join> フィードバックをお寄せください。",
    "newsletterSignup.button": "申し込む",
    "newsletterSignup.email": "メールアドレス",
    "newsletterSignup.country": "国・地域",
    "newsletterSignup.allFieldsRequired": "すべて必須項目です。",
    "newsletterSignup.terms": "このフォームを送信することで、当社の<terms>利用規約</terms>および<privacy>プライバシーポリシー</privacy>に同意したものと見なされます。",
    "newsletterSignup.termsLink": "https://circleci.com/ja/legal/terms-of-use/",
    "newsletterSignup.privacyLink": "https://circleci.com/ja/privacy/",
    "newsletterSignup.joinLink": "https://circleci.com/research/",
    "newsletterSignup.success": "成功",
    "newsletterSignup.error": "問題が発生しました。入力した内容をご確認ください。",
    "OrbDetails.OrbStatusBadge.certified": "Certified",
    "OrbDetails.OrbStatusBadge.partner": "Partner",
    "OrbDetails.OrbStatusBadge.private": "Private",
    "OrbDetails.OrbShowHeader.categories": "Categories:",
    "OrbDetails.OrbShowHeader.homepage": "Homepage:",
    "OrbDetails.OrbShowHeader.orbCreated": "Created:",
    "OrbDetails.OrbShowHeader.orgUsage": "Org Usage:",
    "OrbDetails.OrbShowHeader.orgUsageTooltip": "Number of organizations that have used an orb in the past 30 days",
    "OrbDetails.OrbShowHeader.releases": "Releases:",
    "OrbDetails.OrbShowHeader.source": "Source:",
    "OrbDetails.OrbShowHeader.versionPublished": "Version Published:",
    "OrbDetails.OrbShowHeader.licensing": "See Orb Licensing",
    "OrbDetails.OrbShowHeader.reportOrb": "Report this Orb",
    "OrbDetails.OrbShowLayout.commands": "Commands",
    "OrbDetails.OrbShowLayout.executors": "Executors",
    "OrbDetails.OrbShowLayout.jobs": "Jobs",
    "OrbDetails.OrbShow.title": "CircleCI Developer Hub - {orbFullName}",
    "OrbDetails.OrbShow.copyCode": "Copy This Code",
    "OrbDetails.OrbShow.formattedDefaultValue": "[sequence of length {length}] see source",
    "OrbDetails.OrbShow.licenseSource": "# This code is licensed from CircleCI to the user under the MIT license.\n# See here for details: ",
    "OrbDetails.OrbShow.orbsBreadcrumb": "Orbs",
    "OrbDetails.OrbShow.orbSource": "Orb Source",
    "OrbDetails.OrbShow.parameterTableHeaderName": "PARAMETER",
    "OrbDetails.OrbShow.parameterTableHeaderDescription": "DESCRIPTION",
    "OrbDetails.OrbShow.parameterTableHeaderRequired": "REQUIRED",
    "OrbDetails.OrbShow.parameterTableHeaderDefault": "DEFAULT",
    "OrbDetails.OrbShow.parameterTableHeaderType": "TYPE",
    "OrbDetails.OrbShow.parameterType": "type: {type}",
    "OrbDetails.OrbShow.quickStartGuide": "Orb Quick Start Guide",
    "OrbDetails.OrbShow.quickStartStep1A": "Use CircleCI version 2.1 at the top of your .circleci/config.yml file.",
    "OrbDetails.OrbShow.quickStartStep2": "Add the <code>orbs</code> stanza below your version, invoking the orb:",
    "OrbDetails.OrbShow.quickStartStep3": "Use <code>{orbName}</code> elements in your existing workflows and jobs.",
    "OrbDetails.OrbShow.quickStartCertifiedStep1A": "Opt-in to use of uncertified orbs on your organization’s Security settings page.",
    "OrbDetails.OrbShow.quickStartCertifiedStep1B": "Read more in the docs here.",
    "OrbDetails.OrbShow.required": "Required",
    "OrbDetails.OrbShow.sideBarQuickStartGuide": "Orb Quick Start Guide",
    "OrbDetails.OrbShow.sideBarUsageExamples": "Usage Examples",
    "OrbDetails.OrbShow.sideBarOrbSource": "Orb Source",
    "OrbDetails.OrbShow.sourceHide": " Hide ",
    "OrbDetails.OrbShow.sourceShow": " Show ",
    "OrbDetails.OrbShow.source": " Source",
    "OrbDetails.OrbShow.usageExamples": "Usage Examples",
    "OrbDetails.OrbShow.yes": "Yes",
    "OrbDetails.OrbShow.no": "No",
    "OrbList.DropdownBadgeTypeFilters.all": "すべて",
    "OrbList.DropdownBadgeTypeFilters.certifiedAndPartner": "承認済みとパートナー製",
    "OrbList.DropdownBadgeTypeFilters.popular": "人気",
    "OrbList.CategoryFilters.placeholder": "選択",
    "OrbList.OrbList.searchBoxHeader": "Orb の検索",
    "OrbList.OrbList.typeFilterHeader": "Orb の種類で絞り込み",
    "OrbList.OrbList.categoryFilterHeader": "カテゴリの選択",
    "OrbList.OrbList.tooltip": "承認済みとパートナー製: CircleCI チームとテクノロジー パートナーが作成し、テストした Orb\n人気: 3 つ以上の組織で使用されている Orb",
    "OrbList.PageNavigation.results": "Results: {start}-{end} of {numResults}",
    "OrbList.SearchBox.placeholder": "検索",
    "OrbList.SearchResults.headerName": "名前",
    "OrbList.SearchResults.headerDescription": "説明",
    "OrbList.SearchResults.headerLastModified": "最終更新日",
    "OrbList.SearchResults.headerOrgUsage": "ORG USAGE",
    "OrbList.SearchResults.lastModifiedOn": "最終更新日",
    "OrbList.SearchResults.orgUsage": "Org usage",
    "OrbList.SearchResults.orgUsageTooltip": "Number of organizations that have used an orb in the past 30 days",
    "OrbList.SearchResults.showMore": "表示を増やす",
    "orbs_insights.orbs.title": "Orb: 再利用可能な設定",
    "orbs_insights.orbs.featureDescription": "手動タスクの自動化",
    "orbs_insights.orbs.content": "Orb は CircleCI のパッケージマネージャーです。チーム間で共有でき、設定ファイルを最新の、同期した状態に保つことができます。",
    "orbs_insights.orbs.badgeHeading": "POPULAR ORBS",
    "orbs_insights.insights.title": "インサイト: パフォーマンスメトリクス",
    "orbs_insights.insights.featureDescription": "時間と費用の節約",
    "orbs_insights.insights.content": "CircleCI のインサイトダッシュボードを使ってパイプライン全体のヘルスを評価し、ビルドを迅速化する方法を見つけましょう。",
    "orbs_insights.insights.badgeHeading": "MONITOR SPEED AND SPEND",
    "shared.MobileSectionsNavContainer.sections": "Sections",
    "shared.SearchStatusIndicator.searchStatusError": "申し訳ありません。検索の実行中にエラーが発生しました。",
    "shared.SearchStatusIndicator.searchStatusNoResults": "申し訳ありません。ご指定の検索語句に該当する結果が見つかりませんでした。",
    "shared.orbSearch.noResultsMessage1": "申し訳ありません。ご指定の検索語句に該当する Orb が見つかりませんでした。必要な機能を備えた<create> Orb をご自身で作成してみませんか?</create>",
    "shared.orbSearch.noResultsLink": "https://circleci.com/docs/ja/creating-orbs",
    "shared.orbSearch.errorMessage": "Orb の取得中にエラーが発生しました。ページを更新して、もう一度お試しください。",
    "shared.FormattedCode.copy": "コピー",
    "links.external.home": "https://circleci.com/ja/",
    "links.external.docs": "https://circleci.com/docs/ja/",
    "links.external.imageDocs": "https://circleci.com/docs/ja/circleci-images",
    "links.external.machineDocs": "https://circleci.com/docs/ja/executor-types?section=executors-and-images#machine-%E3%81%AE%E4%BD%BF%E7%94%A8",
    "links.external.privateOrb": "https://circleci.com/docs/orb-intro",
    "links.external.orbDocs": "https://circleci.com/docs/ja/orb-intro",
    "links.external.signup": "https://www.circleci.com/ja/signup",
    "links.external.vcs-authorize": "https://circleci.com/ja/vcs-authorize",
    "links.social.blogFeed": "https://circleci.com/blog/feed.xml",
    "links.social.facebook": "https://www.facebook.com/circleci",
    "links.social.twitter": "https://twitter.com/CircleCIJapan",
    "links.social.linkedIn": "https://www.linkedin.com/company/circleci",
    "links.social.github": "https://github.com/circleci",
    "links.external.termsOfUse": "https://circleci.com/ja/legal/terms-of-use/",
    "links.external.privacyPolicy": "https://circleci.com/ja/privacy/",
    "links.external.cookiePolicy": "https://circleci.com/ja/legal/cookie-policy/",
    "links.external.security": "https://circleci.com/ja/security/",
    "links.external.pricing": "https://circleci.com/ja/pricing/",
    "links.external.getStarted": "https://circleci.com/docs/ja/getting-started/",
    "links.external.signUp": "https://circleci.com/ja/signup/",
    "links.external.quickstartGuide": "https://circleci.com/docs/ja/getting-started/",
    "links.external.onDemandCourse": "https://circleci.com/ja/training/",
    "links.external.examplesGuides": "https://circleci.com/docs/ja/examples-and-guides-overview/",
    "links.external.configIntro": "https://circleci.com/docs/ja/config-intro/",
    "links.external.sampleConfig": "https://circleci.com/docs/ja/sample-config/",
    "links.external.configReference": "https://circleci.com/docs/ja/configuration-reference/",
    "links.external.orbsIntro": "https://circleci.com/docs/ja/orb-intro/",
    "links.internal.nodeOrb": "https://circleci.com/developer/ja/orbs/orb/circleci/node/",
    "links.internal.androidImage": "https://circleci.com/developer/ja/images/image/cimg/android/",
    "links.external.tokens": "https://circleci.com/docs/ja/openid-connect-tokens/",
    "links.external.macOS": "https://circleci.com/ja/changelog/#new-macos-cloud-ips/",
    "links.external.IP": "https://circleci.com/docs/ja/ip-ranges/#circleci-macos-cloud/",
    "links.internal.orbFeature": "/ja/orbs",
    "links.internal.slack": "/ja/orbs/orb/circleci/slack/",
    "links.internal.aws": "/ja/orbs?query=aws&page=1&pageSize=15&filterBy=certifiedAndPartner/",
    "links.internal.node": "/ja/orbs/orb/circleci/node/",
    "links.external.insightsFeatureLoggedIn": "https://app.circleci.com/insights/",
    "links.external.insightsFeatureLoggedOut": "https://circleci.com/docs/ja/insights/",
    "links.external.responseTime": "https://circleci.com/docs/ja/optimizations/",
    "links.external.credits": "https://circleci.com/docs/ja/insights-glossary/?highlight#organization-level-metrics/",
    "links.external.tests": "https://circleci.com/docs/ja/test-splitting-tutorial/",
    "links.external.newFeatures": "https://circleci.com/ja/changelog/",
    "links.external.integrations": "https://circleci.com/ja/integrations/",
    "links.external.languageGuides": "https://circleci.com/docs/ja/examples-and-guides-overview/",
    "links.external.webhooks": "https://circleci.com/docs/ja/webhooks/",
    "indexPage.title": "CircleCI デベロッパー ハブ",
    "indexPage.pageDescription": "開発者ホーム",
    "indexPage.metaDescription": "CircleCI のデベロッパーハブへようこそ。Developer Hubでは、Docker イメージ、設定パッケージ（Orbs)、ドキュメント、API、CLIなどのリソースを提供しています。",
    "gettingStarted.heading": "はじめに",
    "gettingStarted.subhead": "CI/CD の<ci>基礎</ci>と <about>CircleCI のしくみ</about>を理解しましょう。そして、入門ガイドを参考に、CircleCI で初めてのプロジェクトをセットアップしましょう。",
    "gettingStarted.subheadCILink": "https://circleci.com/ja/continuous-integration/",
    "gettingStarted.subheadAboutLink": "https://circleci.com/ja/docs/about-circleci#section=welcome",
    "gettingStarted.cta1Text": "Hello World",
    "gettingStarted.cta1Link": "https://circleci.com/docs/ja/hello-world#section=getting-started",
    "gettingStarted.cta2Text": "入門ガイド",
    "gettingStarted.cta2Link": "https://circleci.com/docs/ja/getting-started#section=getting-started",
    "config.heading": "CircleCI の設定ファイル",
    "config.subhead": "CircleCI は Configuration as Code の理念を掲げています。これは、ビルドからデプロイまでのデリバリー プロセス全体が config.yml という 1 つのファイルを通じてオーケストレーションされることを表しています。CircleCI のパイプライン階層についてと、YAML ファイルを正しくセットアップする方法をご確認ください。",
    "config.cta1Text": "CircleCI 設定ファイル入門",
    "config.cta1Link": "https://circleci.com/docs/ja/config-intro#section=configuration",
    "config.migrationGuides": "他の CI ツールからの移行ガイド",
    "config.migrationGuidesLink": "https://circleci.com/docs/ja/migration-intro#section=getting-started",
    "config.jenkinsfileConverter": "Jenkinsfile コンバーター",
    "config.tipsForOptimizing": "CI 構成を最適化するヒント",
    "config.tipsForOptimizingLink": "https://circleci.com/ja/blog/six-optimization-tips-for-your-config/",
    "orbs.heading": "CircleCI Orbs",
    "orbs.subhead": "Orb は、開発プロセスのスピードアップを目的として構成内容をまとめた共有可能なパッケージです。<orbs>パブリック Orb レジストリ</orbs>では、数千種に及ぶ Orb が公開されています。また、<plans>有料プラン</plans>にお申し込みいただくと、組織専用のプライベート Orbs を作成することも可能です。",
    "orbs.cta1Text": "Orbs ライブラリ",
    "orbs.learnMore": "詳しく見る",
    "orbs.learnMoreLink": "https://circleci.com/ja/orbs/",
    "orbs.exploreDocs": "ドキュメントを読む",
    "orbs.exploreDocsLink": "https://circleci.com/docs/ja/orb-intro#section=configuration",
    "featuredOrb.link": "/orbs/orb/circleci/node",
    "featuredOrb.heading": "注目の Orb: Node",
    "featuredOrb.name": "Node.js",
    "featuredOrb.description": "Node.js とそのパッケージ マネージャー (npm、yarn) を簡単にインストールできます。キャッシュがデフォルトで有効になっているパッケージをインストールできる点が特長です。",
    "featuredOrb.namespace": "circleci/node",
    "featuredOrb.label": "承認済み",
    "featuredOrb.seeAll": "すべての Orb を見る",
    "images.heading": "Docker 用のコンビニエンス イメージ",
    "images.subhead": "CircleCI では、CI/CD 環境向けに、さまざまなプログラミング言語やいくつかのデータベースに対応した各種 Docker イメージを提供しています。環境をコンテナ化する際の簡単で便利な叩き台として、このイメージを活用できます。",
    "images.exploreImages": "イメージの一覧",
    "images.dockerBasics": "Docker の基礎チュートリアル",
    "images.dockerBasicsLink": "https://circleci.com/ja/blog/docker-and-cicd-tutorial-a-deep-dive-into-containers/",
    "images.viewDocs": "ドキュメントを読む",
    "images.viewDocsLink": "https://circleci.com/docs/ja/executor-intro#section=configuration",
    "machine.heading": "Machine Images for CircleCI",
    "machine.subhead": "CircleCI maintains a fleet of Docker images for a CI/CD environment that are compatible with multiple programming languages and a few databases. Use images as a quick and convenient starting point for your containerized environment.",
    "machine.exploreImages": "Explore Images",
    "machine.machineBasics": "Machine Basics Tutorial",
    "machine.dockerBasicsLink": "https://circleci.com/blog/docker-and-cicd-tutorial-a-deep-dive-into-containers/",
    "machine.viewDocs": "View Docs",
    "machine.viewDocsLink": "https://circleci.com/docs/executor-intro#section=configuration",
    "featuredImage.link": "/images/image/cimg/node",
    "featuredImage.heading": "注目のイメージ: cimg/node",
    "featuredImage.name": "cimg/node",
    "featuredImage.description1": "各タグには、Node.js の特定のバージョンと、",
    "featuredImage.description2": "npm",
    "featuredImage.description3": "、",
    "featuredImage.description4": "yarn v1",
    "featuredImage.description5": "、および CircleCI 環境でビルドを正常に完了させるために必要なバイナリとツールが含まれています。",
    "featuredImage.versionLabel": "最新バージョン: ",
    "featuredImage.seeAll": "すべてのイメージを表示する",
    "integrations.heading": "インテグレーションとインターフェイス",
    "integrations.subhead": "既存のツールチェーンと統合し、CircleCI の Orb、API、CLI、CircleCI Webhook を使用して生産性を維持します。",
    "integrations.cta1Text": "CircleCI のインテグレーション",
    "integrations.cta1Link": "https://circleci.com/ja/integrations/",
    "integrations.cta2Text": "承認済み Orb とパートナー製 Orb",
    "webhooks.heading": "Webhook",
    "webhooks.subhead": "CircleCI Webhook を使用すると、CircleCI のワークフロー/ジョブ レベルのイベントと連携する仕組みを独自に作成できます。",
    "webhooks.cta1Text": "Webhook の詳細を見る",
    "webhooks.cta1Link": "https://circleci.com/docs/ja/webhooks",
    "api.heading": "API",
    "api.subhead": "アプリケーションまたはシステム内のアクションを自動化するツールを作成できます。",
    "api.cta1Text": "CircleCI API の一覧",
    "api.cta1Link": "https://circleci.com/docs/api/v2/#circleci-api",
    "cli.heading": "CLI",
    "cli.subhead": "CLI をインストールすれば、ローカル ターミナルから CircleCI の高機能ツールを使用できます。",
    "cli.cta1Text": "CircleCI CLI の詳細",
    "cli.cta1Link": "https://circleci.com/docs/ja/local-cli",
    "cli.install": "CLI のインストール",
    "cli.installLink": "https://github.com/CircleCI-Public/circleci-cli",
    "resources.heading": "関連資料",
    "resources.subhead": "CI/CD パイプラインのセットアップや効率的な手法の運用は、我流で行うべきではありません。CircleCI のエキスパートや CircleCI コミュニティが提供するリソースやベスト プラクティスを活用しましょう。",
    "docs.heading": "ドキュメント",
    "docs.subhead": "これから CI/CD を始める人はもちろん、経験を積んだ開発者にも、CircleCI を使いこなすうえで役立つチュートリアル、サンプル、ハウツー ガイドをドキュメント サイトにご用意しています。",
    "docs.cta1Text": "ドキュメントを読む",
    "docs.cta1Link": "https://circleci.com/docs/ja/",
    "docs.helloWorld": "Hello World",
    "docs.helloWorldLink": "https://circleci.com/docs/ja/hello-world#section=getting-started",
    "learning.heading": "学習資料",
    "learning.subhead": "CircleCI Academy で無料の開発者向けトレーニングをご利用いただけます。ブログには、テクニカル チュートリアルやさまざまな視点の記事を掲載しています。CircleCI のエキスパート チームから知識を吸収し、オンボーディングの取り組みをカスタマイズしましょう。",
    "learning.cta1Text": "CircleCI Academy",
    "learning.cta1Link": "https://circleci.com/ja/training/",
    "learning.blogTutorials": "ブログのチュートリアル記事",
    "learning.blogTutorialsLink": "https://circleci.com/ja/blog/tag/tutorials/",
    "learning.webinars": "最近のウェビナー",
    "learning.webinarsLink": "https://www.youtube.com/playlist?list=PL9GgS3TcDh8yzDPyWHcBzZg0KetWB1hMY",
    "community.heading": "コミュニティとサポート",
    "community.subhead": "サポートが必要なときに、CircleCI はもちろん、60 万人以上が参加し、今もメンバーが増加中のコミュニティからも支援を受けることができます。",
    "community.cta1Text": "コミュニティ フォーラム",
    "community.cta1Link": "https://discuss.circleci.com/",
    "community.premiumSupport": "プレミアム サポート",
    "community.premiumSupportLink": "https://circleci.com/ja/support/premium-support/",
    "community.expert": "サポート情報",
    "community.expertLink": "https://support.circleci.com/hc/ja",
    "imagesPage.title": "CircleCI イメージ (cimg)",
    "imagesPage.pageDescription": "イメージ",
    "imagesPage.shortDescription": "CircleCIでは、様々なプログラミング言語、データベース、OS用のイメージを保持しています。",
    "imagesPage.metaDescription": "CircleCIでは、様々なプログラミング言語、データベース、OS用のイメージを保持しています。",
    "imagesPage.docsLinkText": "ドキュメントを読む",
    "imagePage.title": "{imageName} - CircleCI",
    "imagePage.imagesBreadcrumb": "コンビニエンス イメージ",
    "machinePage.title": "CircleCI 開発者 - コンビニエンス イメージ{imageName} - CircleCI",
    "machinePage.pageDescription": "コンビニエンス イメージ",
    "machinePage.shortDescription": "Use these images in your configuration to match the virtual machine required for your specific job.",
    "machinePage.metaDescription": "これらのイメージを活用して、特定のジョブに必要な仮想マシン (VM) に合わせて構成しましょう。",
    "machinePage.docsLinkText": "ドキュメントを読む",
    "machinePage.machineBreadcrumb": "コンビニエンス イメージ",
    "orbsPage.title": "CircleCI Developer - Orbs",
    "orbsPage.pageDescription": "Orbs",
    "orbsPage.shortDescription": "Orb は構成内容をまとめた共有可能なパッケージであり、ビルド プロセスの効率化に役立ちます。以下の CircleCI Orb レジストリで各種パートナー、コミュニティ、CircleCI が作成したパブリック Orb を選べるほか、お客様専用の<link>プライベート Orbs</link> を作成できます。",
    "orbsPage.metaDescription": "CircleCIのOrbsを活用すれば、コマンド、Executors、ジョブなどの構成をパッケージ化、配信、再利用の実現を可能にさせ、繰り返されるプロセスを自動化し、セットアップをより高速化、簡単に統合することができます。",
    "orbsPage.docsLinkText": "ドキュメントを読む",
    "orbsPage.orbDelay.title": "Newly published orbs",
    "orbsPage.orbDelay.content": "may not appear on this page for up to 30 minutes.",
    "orbsLicensing.title": "CircleCI Developer - Orb Licensing",
    "orbsLicensing.pageDescription": "Orb Licensing",
    "orbsLicensing.metaDescription": "Orbs authors agree to the CircleCI Code Sharing Terms of Service when their organizations opt-in to 3rd party orb use and authoring.",
    "orbsLicensing.orbLicense.subHeader": "Orbs License",
    "orbsLicensing.orbLicense.subDetail1": "Orbs authors agree to our ",
    "orbsLicensing.orbLicense.tosInlineLink": "https://circleci.com/ja/legal/code-sharing-terms/",
    "orbsLicensing.orbLicense.tosInlineText": "Code Sharing Terms of Service ",
    "orbsLicensing.orbLicense.subDetail2": "when their organizations opt-in to 3rd party orb use and authoring. CircleCI thereby licenses all orbs back to users under the ",
    "orbsLicensing.orbLicense.mitInlineLink": "https://opensource.org/licenses/MIT",
    "orbsLicensing.orbLicense.mitInlineText": "MIT License agreement.",
    "orbsLicensing.orbMitLicense.subHeader": "Official MIT License Terms",
    "orbsLicensing.orbMitLicense.subDetail1": "Copyright 2020 Circle Internet Services, Inc.",
    "orbsLicensing.orbMitLicense.subDetail2": "Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the \"Software\"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:",
    "orbsLicensing.orbMitLicense.subDetail3": "The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.",
    "orbsLicensing.orbMitLicense.subDetail4": "THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.",
    "orbPage.title": "CircleCI Developer Hub - {orbFullName}",
    "orbPage.orbsBreadcrumb": "Orbs",
    "orbsReport.title": "CircleCI Developer - Reporting an Orb",
    "orbsReport.pageDescription": "Reporting an Orb",
    "orbsReport.metaDescription": "Steps to report a CircleCI Orb for any malicious behavior or accidental leak of private information.",
    "orbsReport.when.header": "When should I report an orb?",
    "orbsReport.when.detail": "There are two reasons to report an orb: ",
    "orbsReport.when.detailItem1Key": "Malicious Orbs: ",
    "orbsReport.when.detailItem1Value": "The orb’s content poses a threat to the orb’s users. Examples may include an orb that mines cryptocurrency, or that uploads credentials to a malicious URL.",
    "orbsReport.when.detailItem2Key": "Accidental Leakage of Private Data: ",
    "orbsReport.when.detailItem2Value": "The orb’s content poses a threat to the orb author. For example, a user might have hardcoded AWS keys inside their orb during development, and forgotten to remove it when they published the orb.",
    "orbsReport.what.header": "What happens after I report an orb?",
    "orbsReport.what.detail1": "Your orb report will be reviewed by the CircleCI security team as soon as possible, and responded to in due course.",
    "orbsReport.what.detail2": "Malicious orbs will be removed immediately.",
    "orbsReport.what.detail3": "Orbs accidentally leaking private data will be weighed by the potential harm to the orb’s users (from breaking their builds, or transitively removing the orbs they’ve authored) and the harm to the orb’s author.",
    "orbsReport.what.detail4": "In case of the latter, it’s important to note that once the orb is published, it is public. CircleCI has no way to determine whether a third party has accessed the orb, however briefly it was published. A user who has published a credential or other secret into an orb should consider themselves compromised and start rolling credentials.",
    "orbsReport.how.header": "How do I report an orb? ",
    "orbsReport.how.detail1": "Contact our security team by following the instructions here (including use of encryption keys if you are reporting a serious security vulnerability): ",
    "orbsReport.how.securityLink": "https://circleci.com/ja/security/",
    "orbsReport.how.detail2": "It’s helpful to include a link to the orb you’re reporting and some details about why this orb qualifies for review."
  }
};
export default i18nTranslations;
